// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__BxV-U","stageWrapper":"layout_stageWrapper__0PRcG","stage":"layout_stage__xiDzj","footer":"layout_footer__C83ht","footerLogo":"layout_footerLogo__13XIO"};